export default {
  async parseSearch({ commit, state }) {
    const results = this.state.searchbar.searchResults
    if (results.length) {
      const parseResults = JSON.parse(JSON.stringify(results))
      const data = parseResults.map((x, i) => {
        // parse airport poi
        if (x.type === 2) x['typeSearch'] = 'airport'
        return x
      })
      const type = [...new Set(data.map(({ type }) => type))]
      const types = [...new Set(data.map(({ typeSearch }) => typeSearch))]
      const groupBy = function (xs, key) {
        return xs.reduce(function (rv, x) {
          ;(rv[x[key]] = rv[x[key]] || []).push(x)
          return rv
        }, {})
      }
      const dataGrouped = groupBy(data, 'typeSearch')
      commit('searchbar/seResultFilter', { type, types, dataGrouped }, { root: true })
    } else commit('searchbar/seResultFilter', {}, { root: true })
  },
  async autoCompleteRD({ commit, state, getters }, term) {
    await this.$apiSearchbar.autocomplete(term, {}).then((response) => {
      commit('setSearchTerm', response[0][0].name)
      commit('setResults', [response[0][0]])
      commit('setResultSelected', { value: response[0][0], key: 'autocomplete' })
    })
  },
  fillAutocomplete({ commit, state, getters }, data) {
    const model = [
      {
        name: data.nameHotel,
        countryName: data.address.country,
        city: data.address.city,
        num_hotels: '1',
        type: 4,
        locality: `${data.address.city}, ${data.address.country}`,
        typeSearch: 'hotel',
        tcm: data.hotelTCM,
        code: data.backCodeTMS,
        url: '',
        brand: data.brand,
        cityKey: 'Madrid',
        countryKey: '',
        vh: false,
        ebp: false,
        gha: false,
        minor: false,
        df: 'DD/MM/YYYY'
      }
    ]
    commit('setResults', model)
    commit('setSearchTerm', data.backCodeTMS)
    commit('setResultSelected', { value: model[0], key: 'autocomplete' })
  },
  async handleSearchSubmit({ commit, state, getters, dispatch }, nuxtContext) {
    const context = this
    const queryParams = buildQueryParams(state, getters, this.$i18n.locale, commit)
    const selected = getters.getSearchSelected()
    const url = buildUrl(queryParams)

    let arrayBrand = []

    if(url.link.includes("booking-b2b")){
      //Brands to redirect when we are in b2b booking
      arrayBrand = ["anantara"]
    }else{
      //Brands to redirect when we are in b2c booking
      arrayBrand = ["avani", "tivoli", "anantara"]
    }

    const isExternalHotel = selected.autocomplete.ebp && selected.autocomplete.url !== ''

    //Brand of the selected hotel in autocomplete
    const brand = selected && selected.autocomplete && selected.autocomplete.brand
      ? selected.autocomplete.brand.toLowerCase()
      : '';

    //Check if the selected item is an hotel and the arrayBrand has the objective brand
    const typeSearch = selected && selected.autocomplete && selected.autocomplete.typeSearch
      ? selected.autocomplete.typeSearch
      : '';

    const isBrandRedirect = typeSearch === 'hotel' &&
      arrayBrand.includes(brand) &&
      !window.location.origin.includes(brand);

    let findTerm = '';

    //This is needed because we get "nh collection" as brand from the autocomplete, but in locales.js the brand is "collection"
    if (isBrandRedirect) {
      findTerm = brand.includes('nh collection') ? 'collection' : brand;
    }

    //If brandRedirect is true, we get the domain from the locales object
    const brandLocales = isBrandRedirect && !isExternalHotel ? process.env.locales[findTerm] : null

    const domainUrl = domainEnviroment(url, selected.autocomplete, selected.nearme, context, brandLocales, context.$i18n.locale)

    if (window.location.port !== '4000') commit('reservation/setModifiedSearch', true, { root: true })

    if (state.hotel && queryParams.hotelId !== state.hotel.backCodeTMS && !isExternalHotel) {
      commit('setHotel', null)
    }

    if (selected.nearme || selected.autocomplete.type !== 4) {
      const u = new URLSearchParams(url.queryParams).toString()
      window.location.href = domainUrl + '?' + decodeURIComponent(u)
    } else if (isExternalHotel) {
      try {
        const isB2c = nuxtContext.$store.state.nhAuth.isB2C
        const TOKENSSO = sessionStorage.getItem('NHTKN')
        const urlRedirect = externalHotel(queryParams, selected, context)
        if (TOKENSSO && isB2c) {
          commit('setExternalRedirect', urlRedirect)
          try {
            await nuxtContext.$apiSearchbar
              .ssoApiLoginExternalToken(process.env.environmentName, TOKENSSO)
              .then((response) => {
                const dataToken = response.data ? response.data.mbe_access_token : response.mbe_access_token
                const urlRedirect = externalHotel(queryParams, selected, context, dataToken)
                commit('setExternalRedirect', urlRedirect)
                nuxtContext.$root.$emit('bv::show::modal', 'modal-crossDomain')
                nuxtContext.$emit('close-searchabar')
              })
              .catch((error) => {
                window.location.href = urlRedirect
              })
          } catch (error) {
            window.location.href = urlRedirect
          }
        } else {
          window.location.href = urlRedirect
        }
      } catch (error) {
        console.log('Error url Externa', error)
        nuxtContext.$emit('close-searchabar')
      }
    } else if (isBrandRedirect) {
      const u = new URLSearchParams(url.queryParams).toString()
      //window.location.href = domainUrl + '?' + decodeURIComponent(u)
      const path = state.paths.rd
      window.location.href = '/' + context.$i18n.locale + path + '?' + decodeURIComponent(u)
    } else {
      // internal link
      const path = state.paths.rd
      if (window.location.port === '4000' || window.location.href.indexOf(`${path}`) != -1) {
        commit('setModule', null)
        const u = new URLSearchParams(url.queryParams).toString()
        window.location.href = '/' + context.$i18n.locale + path + '?' + decodeURIComponent(u)
    /*     this.$router.push({
          path: `${domainUrl}`,
          query: url.queryParams,
          force: true
        }) */
      } else {
        const u = new URLSearchParams(url.queryParams).toString()
        const path = state.paths.rd
        window.location.href = '/' + context.$i18n.locale + path + '?' + decodeURIComponent(u)
        //window.location.href = domainUrl + '?' + decodeURIComponent(u)
      }
    }
  },
  setPaths({ commit }, data) {
    commit('setPaths', data)
  }
}

const buildQueryParams = (state, getters, lang, commit) => {
  const selected = getters.getSearchSelected()
  const searchParam = getters.getSearchQuerySearch()
  const queryParams = {
    fini: selected.dates.fini,
    fout: selected.dates.fout,
    voucherCode: selected.voucherCode || '',
    pcode: searchParam && searchParam.pcode ? searchParam.pcode : '',
    gvoucher: searchParam && searchParam.gvoucher ? searchParam.gvoucher : '',
  }
  if (searchParam && searchParam.bd && searchParam.bd !== '') {
    queryParams.bd = searchParam.bd
  }
  if (searchParam && searchParam.divisa && searchParam.divisa !== '') {
    queryParams.divisa = searchParam.divisa
  }
  if(selected.autocomplete.brand && selected.autocomplete.brand !== ''){
    queryParams.bdhotel = selected.autocomplete.brand;
  }
  const b2bQuery = b2bParams(state.queryParams, state.b2bParams)
  if (b2bQuery) Object.assign(queryParams, b2bQuery)
  if (selected.nearme) {
    Object.assign(queryParams, destination(selected, lang, state.paths))
  } else {
    if(selected && selected.autocomplete.type &&  selected.autocomplete.num_hotels &&  selected.autocomplete.type === 1 &&  selected.autocomplete.num_hotels === "1"){
      const results = getters.getResultsForCity(selected.autocomplete.city)
      if(results) commit('setResultSelected', { value: results, key: 'autocomplete' })
    }
    Object.assign(queryParams, destination(selected.autocomplete, lang, state.paths))
  }
  Object.assign(queryParams, getOcuppancy(selected.occupancy))
  return queryParams
}

const destination = (selected, lang, paths) => {
  const destination = {
    999: (selected, lang) => ({
      // nearme
      urlPath: getUrlRP(lang) + 'around-me',
      busqId: Date.now(),
      latitude: selected.nearmeLocation.lat,
      longitude: selected.nearmeLocation.lng,
      nearMe: true
    }),
    4: (selected) => ({
      // hotel
      urlPath: `${paths.rd}`,
      hotelId: selected.code
    }),
    2: (selected, lang) => ({
      // airport
      urlPath: getUrlRP(lang),
      pathname: selected.titleKeyword,
      poiId: selected.code,
      busqId: Date.now()
    }),
    1: (selected, lang) => ({
      // city
      urlPath: getUrlRP(lang),
      pathname: selected.cityKey,
      busqId: Date.now(),
      destinationId: selected.code
    }),
    3: (selected, lang) => ({
      // poi
      urlPath: getUrlRP(lang),
      pathname: selected.titleKeyword,
      poiId: selected.code,
      busqId: Date.now()
    }),
    default: (selected, lang) => ({
      urlPath: getUrlRP(lang),
      pathname: selected.titleKeyword,
      poiId: selected.code,
      destinationId: selected.code,
      busqId: Date.now()
    })
  }

  if (selected.type === undefined && selected.nearme && Object.keys(selected.nearmeLocation).length) {
    return destination[999](selected, lang)
  }
  return (destination[selected.type] || destination['default'])(selected, lang)
}
const b2bParams = (params, dataB2b) => {
  const obj = {}
  Object.keys(params).forEach((key) => {
    if (dataB2b.includes(key)) obj[key] = params[key]
  })
  obj['b2bData.ccgType'] = obj['b2bData.ccgType'] === null ? '' : obj['b2bData.ccgType']
  return Object.keys(obj).length ? obj : null
}

const buildUrl = (params) => {
  const link = params.pathname ? `${params.urlPath}${params.pathname.toLowerCase()}` : params.urlPath
  const queryParams = params
  delete queryParams.pathname
  delete queryParams.urlPath

  return { link, queryParams }
}

const getUrlRP = (lang) => {
  const url = {
    es: () => '/booking/hoteles/',
    en: () => '/booking/hotels/',
    pt: () => '/booking/hoteis/',
    nl: () => '/booking/hotels/',
    fr: () => '/booking/hotels/',
    de: () => '/booking/hotels/',
    it: () => '/booking/alberghi/',
    cn: () => '/booking/hotels/',
    mx: () => '/booking/hoteles/',
    ar: () => '/booking/hoteles/',
    uk: () => '/booking/hotels/',
    co: () => '/booking/hoteles/',
    default: () => '/booking/hotels/'
  }
  return (url[lang] || url['default'])()
}

const domainEnviroment = (url, autocomplete, nearme, context, brandLocales, locale) => {
  const { type, brand } = autocomplete
  const host = window.location.hostname
  const pathname = window.location.pathname
  const splitlang = pathname.split('/')[1]

  const isLocal = host === 'localhost' && process.env.environmentName === 'dev'

  if (!isLocal && brandLocales && type === 4) {
    if (brandLocales.domain) return `https://${brandLocales.domain}/${locale}${url.link}`
  }

  // detect language in url
  let isLang = false
  if (splitlang) {
    isLang = ['en', 'es', 'nl', 'it', 'fr', 'de', 'pt', 'co', 'mx', 'ar'].includes(splitlang)
  }
  const lang = isLang ? `/${splitlang}` : ''

  let domain =
    host === 'localhost' && pathname.indexOf('/searchbar') > -1 && type === 4
      ? '/searchbar'
      : (host === 'localhost' && type !== 4) || nearme
      ? typeof context !== 'undefined' && typeof context.$i18n !== 'undefined' && process.env.domain !== 'vue-layout'
        ? `http://${process.env.domain}${lang}${url.link}`
        : `http://nhdev-ecp.nh-hotels.com${url.link}`
      : `${lang}${url.link}`

  const env = {
    development: (domain) => domain,
    production: () => `${lang}${url.link}`,
    staging: () => `${lang}${url.link}`,
    default: () => `${lang}${url.link}`
  }

  return (env[process.env.NODE_ENV] || env['default'])(domain)
}

const getOcuppancy = (ocuppancy) => {
  const ocuppancyParams = {}
  let room = 0
  Object.entries(ocuppancy).forEach((entry, index) => {
    room = index + 1
    Object.entries(entry[1]).forEach((pos) => {
      const [key, value] = pos
      if (key !== 'total') ocuppancyParams[`${key}${room}`] = value
    })
  })
  return ocuppancyParams
}

// External Hotel
const externalHotel = (queryParams, selected, context, token) => {
  const totalRooms = roomsTotal(selected.occupancy)
  const nights = numNights(queryParams.fini, queryParams.fout, 'DD/MM/YYYY', context.$dayjs)

  const typeformat = selected.autocomplete.df
  const days = {
    fini: queryParams.fini,
    fout: queryParams.fout
  }
  if (typeformat !== 'DD/MM/YYYY') {
    days.fni = context.$dayjs(queryParams.fini, 'DD/MM/YYYY').format(typeformat)
    days.fout = context.$dayjs(queryParams.fout, 'DD/MM/YYYY').format(typeformat)
  }

  const { clientId, sessionId } = getGAIdentifiers()

  const dataUrl = {
    hotelID: queryParams.hotelId,
    checkinDate: days.fini,
    checkoutDate: days.fout,
    nights: nights,
    adults: totalRooms.nadults,
    children: totalRooms.nchilds + totalRooms.nbabies,
    roomsNumber: totalRooms.rooms,
    childages: '',
    clientId,
    sessionId
  }
  let url = selected.autocomplete.url
  if (token) {
    dataUrl.mh_sso = token
    url = selected.autocomplete.url + '&mh_sso=[mh_sso]'
  }
  return parseUrlExternal(url + "&ga_client_id=[clientId]&ga_session_id=[sessionId]", dataUrl)
}

const roomsTotal = (data) => {
  const totalElement = {
    nadults: 0,
    nchilds: 0,
    nbabies: 0,
    rooms: 0
  }
  data.forEach(function (element, index) {
    totalElement.nadults += element.nadults
    totalElement.nchilds += element.nchilds
    totalElement.nbabies += element.nbabies
    totalElement.rooms++
  })
  return totalElement
}

const numNights = (fini, fout, dateFormat = 'DD/MM/YYYY', dayjsFn) => {
  const dateIn = dayjsFn(fini, dateFormat)
  const dateOut = dayjsFn(fout, dateFormat)
  return dateOut.diff(dateIn, 'd', true)
}

const parseUrlExternal = (tpl, data) => {
  return tpl.replace(/\[(.*?)\]/gim, function (match, p1) {
    var prop = p1.trim()
    return data.hasOwnProperty(prop) ? data[prop] : ''
  })
}

function getGAIdentifiers() {
  // Inicializamos los valores
  let gaClientId = null
  let gaSessionId = null

  // Buscar la cookie _ga para el client_id
  const gaCookie = document.cookie.split('; ').find(row => row.startsWith('_ga='))

  if (gaCookie) {
    // Extraer el client_id (tercer y cuarto componente de la cookie _ga)
    const gaClientIdParts = gaCookie.split('=')[1].split('.')
    if (gaClientIdParts.length >= 3) {
      gaClientId = `${gaClientIdParts[2]}.${gaClientIdParts[3] || ''}`.replace(/\.$/, '')
    }
  }

  // Buscar la cookie _ga_<measurement-id> para el session_id
  const gaSessionCookie = document.cookie.split('; ').find(row => row.startsWith('_ga_'))

  if (gaSessionCookie) {
    // Extraer el session_id (también el tercer componente en esta cookie)
    gaSessionId = gaSessionCookie.split('=')[1].split('.')[2]
  }

  // Retornar un objeto con los valores encontrados
  return {
    clientId: gaClientId,
    sessionId: gaSessionId
  }
}
